import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const RESET = 'address/RESET';
export const reset = createAction(RESET);

export const CHANGE_VALUE = 'address/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);

const GET_SEARCH_ADDRESS_LIST = 'address/GET_SEARCH_ADDRESS_LIST';
export const getSearchAddressList = createAction(GET_SEARCH_ADDRESS_LIST, api.getSearchAddressList);

const initialState = {
	address: '',
	currentAddress: '',
	buildingCd: '',
	addressList: [],
	isExist: {
		none: false,
		max: false,
	},
	region: '',
	state: '', // 탁송예약에서 쓰임
	postalCd: '',
	roadPart: '',
	detailPart: '',
	sidoCode: '',
	sidoName: '',
	sigunguCode: '',
	sigunguName: '',
};

export default handleActions(
	{
		[RESET]: () => ({
			address: '',
			currentAddress: '',
			addressList: [],
			isExist: {
				none: false,
				max: false,
			},
			region: '',
			state: '',
			postalCd: '',
			roadPart: '',
			detailPart: '',
		}),

		// [CHANGE_VALUE]: (state, action) => {
		// 	const tempStatus = cloneDeep(state);
		// 	return { ...tempStatus, ...action.payload };
		// },
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				Object.assign(draft, action.payload);
			}),

		...pender({
			type: GET_SEARCH_ADDRESS_LIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const addressList = data || [];
					const isExist = {
						none: data.length === 0,
						max: data.length > 99,
					};

					draft.addressList = addressList;
					draft.isExist = isExist;
				}),
		}),
	},
	initialState,
);
